import { Component, Input } from '@angular/core';

@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  // Should show
  @Input() show: boolean = false;

  // Constructor
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/modal.component.ts